import React from 'react';

function AccountDeleted() {
  return (
    <section className="auth-page contain contain-smaller align-middle">
      <h1>Account Deleted</h1>

      <div>
        <p>Your account has been successfully deleted, and any active subscription has been canceled.</p>
      </div>

      <div>
        <p>
          Return to the <a href="/landing.html" className="link-text">Home page</a>
        </p>
      </div>

      <div className="legal-links">
        <p className="text-center">
          By continuing, you agree to the <br />
          <a href="/legal.html#terms-of-use" className="primary-text">Terms of Use</a> &{' '}
          <a href="/legal.html#privacy-policy" className="primary-text">Privacy Policy</a>
        </p>
      </div>
    </section>
  );
}

export default AccountDeleted;